import {defineMessages} from 'react-intl'

/**
 * Catálogo de Mi perfil (`/profile`). Namespace `admin.profile.*` (Fase 1.11).
 *
 * Los dos paneles de seguridad (2FA y llaves de acceso) vienen de
 * `components/security/` y ya se migraron en la 1.11.b: aquí solo van sus
 * títulos de sección.
 *
 * No se traducen: el nombre del rol (`primaryGroup.name`, dato de BD) ni los
 * mensajes de error del backend, que llegan dentro de `common.error.withMessage`.
 */
export const PROFILE_MESSAGES = defineMessages({
  /**
   * Mensajes de Yup. Se pasan **como argumento** a `.required()` / `.min()`, asi
   * que ni el rule ni el paso 6 del gate los ven (guia §17.bis, trampa 1).
   * Todos reusan `validation.*`; el ingles decia «Password is require».
   */
  vPasswordMin: {
    id: 'validation.password.min',
    defaultMessage: 'Password must be at least 6 characters',
  },
  vPasswordUppercase: {
    id: 'validation.password.uppercase',
    defaultMessage: 'Password must contain at least one uppercase letter',
  },
  vPasswordRequired: {id: 'validation.password.required', defaultMessage: 'Password is required'},
  vPasswordMatch: {id: 'validation.password.match', defaultMessage: 'Passwords must match'},
  vOldPasswordRequired: {
    id: 'validation.oldPassword.required',
    defaultMessage: 'Old password is required',
  },
  vEmailInvalid: {id: 'validation.email.invalid', defaultMessage: 'Invalid email'},
  vEmailRequired: {id: 'validation.email.required', defaultMessage: 'Email is required'},

  // ── Cabecera ──
  /**
   * El separador va con `me-1` en el `<span>`, no con un espacio en el texto:
   * formatjs recorta los espacios de los extremos al extraer.
   */
  roleLabel: {id: 'admin.profile.roleLabel', defaultMessage: 'Role:'},
  inviteReferred: {id: 'admin.profile.inviteReferred', defaultMessage: 'Invite Referred'},
  tabSettings: {id: 'admin.profile.tab.settings', defaultMessage: 'Settings'},
  tabMyNumbers: {id: 'telephony.numbers.title', defaultMessage: 'My Numbers'},

  // ── Avatar ──
  changeAvatar: {id: 'admin.profile.avatar.change', defaultMessage: 'Change avatar'},
  saveAvatar: {id: 'admin.profile.avatar.save', defaultMessage: 'Save avatar'},
  toastAvatarUpdated: {
    id: 'admin.profile.avatar.toast.updated',
    defaultMessage: 'Avatar updated successfully',
  },

  // ── Contraseña ──
  changePassword: {id: 'admin.oneUser.password.title', defaultMessage: 'Change Password'},
  oldPassword: {id: 'admin.profile.password.old', defaultMessage: 'Old password'},
  password: {id: 'admin.users.field.password', defaultMessage: 'Password'},
  confirmPassword: {
    id: 'admin.users.field.confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  placeholderOldPassword: {
    id: 'admin.profile.password.placeholder.old',
    defaultMessage: 'Insert old password',
  },
  placeholderPassword: {
    id: 'admin.profile.password.placeholder.new',
    defaultMessage: 'Insert password',
  },
  placeholderConfirmPassword: {
    id: 'admin.profile.password.placeholder.confirm',
    defaultMessage: 'Confirm password',
  },
  toastPasswordUpdated: {
    id: 'admin.profile.password.toast.updated',
    defaultMessage: 'Password updated successfully',
  },

  // ── Secciones de seguridad (los paneles vienen de components/security/) ──
  twoFactorTitle: {
    id: 'admin.profile.section.twoFactor',
    defaultMessage: 'Two-Factor Authentication',
  },
  passkeysTitle: {id: 'admin.security.passkeys.title', defaultMessage: 'Passkeys'},

  // ── Errores de carga del usuario ──
  errUserIdNotFound: {
    id: 'admin.profile.error.userIdNotFound',
    defaultMessage: 'User ID not found',
  },
  infoLoadingUser: {
    id: 'admin.profile.info.loadingUser',
    defaultMessage: 'Loading user data, please wait...',
  },
  errUserNotAvailable: {
    id: 'admin.profile.error.userNotAvailable',
    defaultMessage: 'User data not available',
  },

  // ── Modal de invitación ──
  inviteTitle: {id: 'admin.profile.invite.title', defaultMessage: 'Invite Referred Agent'},
  inviteLink: {id: 'admin.profile.invite.link', defaultMessage: 'Invitation link'},
  sendInvitation: {id: 'admin.profile.invite.send', defaultMessage: 'Send Invitation'},
  toastInvitationSent: {
    id: 'admin.profile.invite.toast.sent',
    defaultMessage: 'Invitation sent to {email}',
  },

  inviteEmailFailed: {
    id: 'admin.profile.invite.emailFailed',
    defaultMessage:
      'Invitation created, but the email could not be sent. Share this link manually.',
  },
  errInviteFailed: {
    id: 'admin.profile.invite.error.failed',
    defaultMessage: 'Could not create the invitation.',
  },

  // ── Reusadas ──
  email: {id: 'common.field.email', defaultMessage: 'Email'},
  cancel: {id: 'common.action.cancel', defaultMessage: 'Cancel'},
  close: {id: 'common.action.close', defaultMessage: 'Close'},
  saveChanges: {id: 'common.action.saveChanges', defaultMessage: 'Save changes'},
  pleaseWait: {id: 'admin.oneUser.pleaseWait', defaultMessage: 'Please wait...'},
  errorWithMessage: {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
  somethingWrong: {id: 'admin.users.toast.somethingWrong', defaultMessage: 'Something wrong!'},
})

/** Abreviatura de "no registrado": se escribe igual en EN y ES. */
export const NOT_RECORDED = 'N/R'
